import React from 'react';
import { Link } from 'react-router-dom';

const EnquiryButton = () => (
  <div className="position-fixed bottom-0 right-0 m-3">
    <Link className="btn btn-primary" to="/enquiry">Enquiry</Link>
  </div>
);

export default EnquiryButton;
